/* eslint-disable */
let defaultLogoColor = "background:#555299";
try {
  if (localStorage.logoColor) {
    defaultLogoColor = localStorage.logoColor;
  }
} catch (e) { }
let defaultHeadColor = "background:#605ca8";
try {
  if (localStorage.headColor) {
    defaultHeadColor = localStorage.headColor;
  }
} catch (e) { }
let defaultNavColor = "#222d32";
try {
  if (localStorage.navColor) {
    defaultNavColor = localStorage.navColor;
  }
} catch (e) { }
let defaultFontColor = "color:#fff";
try {
  if (localStorage.fontColor) {
    defaultFontColor = localStorage.fontColor;
  }
} catch (e) { }
export default {
  state: {
    collapse: false, // 导航栏收缩状态
    RouterLoad: false, // 菜单和路由是否已经加载
    menuList: [], //导航栏菜单
    logoColor: defaultLogoColor, //logo颜色
    headColor: defaultHeadColor, //头部颜色
    navColor: defaultNavColor, //菜单栏颜色
    fontColor: defaultFontColor, //字体颜色
    loding: false, //整个页面开启loding
    online: true, //在线状态
    login: false,
    token: "",
    client: "",
  },
  getters: {
    collapse (state) {
      // 对应着上面state
      return state.collapse;
    }
  },
  mutations: {
    user (state, status) {
      state.user = status;
    },
    online (state, status) {
      state.online = status;
    },
    login (state, status) {
      state.login = status;
    },
    loding (state, status) {
      state.loding = status;
    },
    onCollapse (state) {
      // 改变收缩状态
      state.collapse = !state.collapse;
    },
    RouterLoad (state, RouterLoad) {
      // 改变菜单和路由的加载状态
      state.RouterLoad = RouterLoad;
    },
    menuList (state, menuList) {
      state.menuList = menuList;
    },
    logoColor (state, color) {
      state.logoColor = color;
      try {
        localStorage.logoColor = color;
      } catch (e) { }
    },
    headColor (state, color) {
      state.headColor = color;
      try {
        localStorage.headColor = color;
      } catch (e) { }
    },
    navColor (state, color) {
      state.navColor = color.slice(color.indexOf("#"));
      try {
        localStorage.navColor = color.slice(color.indexOf("#"));
      } catch (e) { }
    },
    fontColor (state, color) {
      state.fontColor = color;
      try {
        localStorage.fontColor = color;
      } catch (e) { }
    }
  },
  actions: {}
};
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/store/modules/app.js